export const breakpoints = {
  MOBILE: '375px',
  TABLET: '768px',
};
